import React from "react";
import CareerLibrarybanner from "../../AVHRBanner/CareerLibiarybanner2.png";
import { FaCheckCircle } from "react-icons/fa";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import CareerLibraryOne from "../../Images/CareerlibOne.jpg";

function CareerLibrary() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const careerpoints = [
    "🎓 Curated by career coaches, psychologists, and industry experts",
    "🔄 Updated regularly with relevant and verified information",
    "🧭 User-friendly and ideal for self-paced exploration",
    "🤝 Complements other EduSupport services like Psychometric Tests, Counselling & Skill Building",
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={CareerLibrarybanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt="Career Transitioning Banner"
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Edu Support</p>

              <h1 className="career-library-heading">Career Library</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">What Is the Career Library</h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              The EduSupport Career Library is a curated knowledge hub that
              empowers students and professionals with comprehensive insights
              into a wide array of career paths, industries, and job roles — all
              in one place
            </p>
          </div>
        </div>

        <div
          className="py-10 px-4 sm:px-6 lg:px-20 carrerbackgroundcolour pt-2"
          style={{ backgroundColor: "#FFE7C7" }}
        >
          <h2 className="text-center mb-2 avhrProject-h2">🔍 Key Features</h2>
          <div className="grid">
            <div className="col-12 grid">
              {/* Box 1 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaCheckCircle className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🎯</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Career Pathways Explorer
                  </h3>
                  <p className=" avhrProject-p">
                    Explore over 150 career profiles across diverse sectors such
                    as Technology, Healthcare, Arts, Finance, Law, and more.
                    Learn what it takes to succeed in each role, including the
                    key skills required, typical responsibilities, career growth
                    opportunities, and the recommended educational path
                  </p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaCheckCircle className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">📖</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Real-World Job Role Insights
                  </h3>
                  <p className=" avhrProject-p">
                    Gain clarity on both emerging and traditional career roles,
                    understand the differences between similar-sounding
                    positions, and get insights into workplace demands and
                    challenges associated with each
                  </p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaCheckCircle className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🛠️</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Skill Recommendations
                  </h3>
                  <p className=" avhrProject-p">
                    Discover the essential soft and technical skills required
                    for each career, learn how to connect your knowledge to
                    real-world applications, and get practical tips on where and
                    how to develop those skills effectively
                  </p>
                </div>
              </div>

              {/* Box 4 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaCheckCircle className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4"> 🗺️</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Learning Path Suggestions
                  </h3>
                  <p className=" avhrProject-p">
                    Get guided roadmaps from school to job-readiness, with tips
                    on degrees, internships, and building your personal brand
                    for any career
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2 mt-4"
          style={{ backgroundColor: "#FDF6EC" }}
        >
          {/* Content */}
          <div className="col-12 md:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">
              🌟 Why Use EduSupport Career Library
            </h2>
            <ul className="list-none pl-4">
              {careerpoints.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="col-12 md:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={CareerLibraryOne}
              alt=""
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(120deg, #D95C66, #FFE066, #FF6666)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">
              🧭 Ready to Discover the Right Career for You
            </p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Let your curiosity guide you. Explore, learn, and choose with
              confidence
            </h2>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default CareerLibrary;
